export const schema = {
  type: "object",
  properties: {
    pricebookname: { type: "string" },
    description: { type: "string" },
    active: { type: "boolean" },
    isstandard: { type: "boolean" },
  },
};
